// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer___TUVc7"};